import React from 'react';
import { Flex } from 'antd';
import { useDispatch } from 'react-redux';

import { refreshPrerenderUser } from 'actions/prerenderUserActions';
import { dismissSurvey, OnboardingSurvey } from '../../../../OnboardingSurvey';
import { useEvent } from '../../../../events/hooks/useEvent';

interface OnboardingSurveyStepProps {
  onGoNext: (steps?: number) => void;
  isShortSurvey?: boolean;
}

const OnboardingSurveyStep: React.FC<OnboardingSurveyStepProps> = ({ onGoNext, isShortSurvey }) => {
  const dispatch = useDispatch();
  const { track } = useEvent();

  React.useEffect(() => {
    track('Integration: Onboarding Survey Step Viewed');
  }, []);

  // PRE-3134: the Invite Team step always follows the survey, whatever the
  // stored team size answer says — so neither the next step nor the button
  // label branches any more.
  // PRE-3350: reading the user back is what stops the survey redirect. Unlike the
  // standalone survey page this step returns no verdict, so the survey continues even
  // when the refreshed user still reads as incomplete: the redirect that traps a user
  // needs `trackingCodeInstalled`, which the wizard has not set yet, and blocking a
  // new account inside onboarding would be the worse failure.
  const onCompleteSurvey = async () => {
    await dispatch(refreshPrerenderUser());

    onGoNext();
  };

  const onAbandonSurvey = () => {
    dismissSurvey();
    onGoNext();
  };

  const getContinueLabel = () => 'Submit & Continue to Team Setup';

  return (
    <Flex justify="center">
      <OnboardingSurvey
        onCompleteSurvey={onCompleteSurvey}
        onAbandonSurvey={onAbandonSurvey}
        isShortSurvey={isShortSurvey}
        getContinueLabel={getContinueLabel}
      />
    </Flex>
  );
};

export default OnboardingSurveyStep;
